var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-logo[data-v-040a50c6]{display:inline-block;width:275px;height:40px;margin:16px 0 44px 80px}.identity-check[data-v-040a50c6]{background-color:#fafafa;min-height:100%}.identity-check h2[data-v-040a50c6]{font-weight:500;padding-top:34px}.bg[data-v-040a50c6]{max-width:1580px;min-height:800px;background:url(" + escape(require("@/assets/images/detect/bg.png")) + ") 50%/cover no-repeat;margin:0 auto;padding-bottom:90px}.main-content[data-v-040a50c6]{width:1400px;min-height:670px;overflow:hidden;background-color:#fff;margin:0 auto;box-shadow:0 0 20px 0 rgba(57,126,253,.1);border-radius:8px;text-align:center}", ""]);

// exports
